// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_ZN-","cls2":"SimplePaperPodcast-cls2_WT6 SimplePaperPodcast-cls1_ZN-"};